import { useState, useEffect } from 'react';

/**
 * Custom hook for responsive breakpoint detection
 * Returns current device type based on window width
 */
const useResponsiveBreakpoint = () => {
  const [deviceType, setDeviceType] = useState('desktop');

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setDeviceType('mobile');
      } else if (width < 1024) {
        setDeviceType('tablet');
      } else {
        setDeviceType('desktop');
      }
    };

    // Initial check
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    deviceType,
    isMobile: deviceType === 'mobile',
    isTablet: deviceType === 'tablet',
    isDesktop: deviceType === 'desktop',
    isMd: deviceType !== 'mobile', // Medium and up (tablet + desktop)
  };
};

export default useResponsiveBreakpoint;